import { range } from "ramda";
import {
  hasEmptyServiceOptionCosts,
  isEmptyDurations,
} from "../utils/serviceForm";

export default {
  methods: {
    handleRemoveDuration(data) {
      const { slotNumber, durationIndex } = data;
      this.form.appointDurationSlots
        .find((slot) => slot.slotNumber === slotNumber)
        .durations.splice(durationIndex, 1);
    },
    handleAddDuration(slotNumber) {
      this.form.appointDurationSlots
        .find((slot) => slot.slotNumber === slotNumber)
        .durations.push({ startAt: "", endAt: "" });
    },
    handleAddAppointDurationSlot(newQuota, oldQuota, appointCost) {
      const quotaNumbers = range(oldQuota + 1, newQuota + 1);
      const newAppointDurationSlots = quotaNumbers.map((quota) => {
        const slot = {
          slotNumber: quota,
          durations: [{ startAt: "", endAt: "" }],
          defaultDurations: [
            { startAt: "09:00", endAt: "12:00" },
            { startAt: "13:00", endAt: "16:00" },
          ],
          isDefaultDuration: true,
        };
        if (appointCost && this.countAppointCost) {
          const cost = this.countAppointCost(quota, appointCost);
          if (cost > 0) {
            slot.appointCost = cost;
            slot.isAppointCostReadOnly = true;
          }
        }
        return slot;
      });
      this.form.appointDurationSlots = this.form.appointDurationSlots.concat(
        newAppointDurationSlots
      );
    },
    handleRemoveAppointDurationSlot(newQuota, oldQuota) {
      this.form.appointDurationSlots.splice(newQuota, oldQuota - newQuota);
    },
    handleAddDateConstraints(newQuota, oldQuota) {
      const quotaNumbers = range(oldQuota + 1, newQuota + 1);
      const newAppointDateConstraints = quotaNumbers.map((quota) => ({
        slotNumber: quota,
        constraints: 0,
        reference_date_type: "PREVIOUS_APPOINTMENT_DATE",
        type: "APPOINTMENT_GAP",
      }));
      this.form.appointDateConstraints =
        this.form.appointDateConstraints.concat(newAppointDateConstraints);
    },
    handleRemoveDateConstraints(newQuota, oldQuota) {
      this.form.appointDateConstraints.splice(newQuota, oldQuota - newQuota);
    },
    hasEmptyDuration() {
      return this.form.appointDurationSlots.some((slot) =>
        !slot.isDefaultDuration ? isEmptyDurations(slot.durations) : false
      );
    },
    hasEmptyAppointmentCost(appointmentCost) {
      return appointmentCost.some((slot) => !slot.appointCost);
    },
    hasEmptyCombineOption() {
      return hasEmptyServiceOptionCosts(this.form.serviceOptionCosts);
    },
    hasEmptyMainCombineOption() {
      return hasEmptyServiceOptionCosts(this.form.serviceOptionCosts, {
        isExtraOption: false,
      });
    },
    hasEmptyExtraCombineOption() {
      return hasEmptyServiceOptionCosts(this.form.serviceOptionCosts, {
        isExtraOption: true,
      });
    },
    handleCheckCombineOption(value) {
      this.isCheckCombineOption = value;
    },
  },
};
